export default "__VITE_ASSET__KzTjBmJe__"